import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

jQuery(document).ready(function ($) {
  const cards = gsap.utils.toArray('.services__item');
  const items = document.querySelector('.services__items');
  if (!cards.length || !items) return;

  const mm = gsap.matchMedia();
  let isDesktop = false;
  let mainTimeline = null;

  const getTallestCardHeight = () => {
    let max = 0;
    cards.forEach((card) => {
      max = Math.max(max, card.scrollHeight);
    });
    return max;
  };

  const setItemsMinHeight = (height, animate = false) => {
    if (!isDesktop || !items) return;
    if (animate) {
      gsap.to(items, {
        minHeight: height + 20,
        duration: 0.4,
        ease: 'power2.inOut',
        overwrite: 'auto',
      });
    } else {
      items.style.minHeight = `${height + 20}px`;
    }
  };

  const resetFlexBasis = (card) => {
    const image = card.querySelector('.services__item-image');
    const content = card.querySelector('.services__item-content');

    if (image)
      gsap.to(image, { flexBasis: '', duration: 0.3, ease: 'power2.inOut' });
    if (content)
      gsap.to(content, { flexBasis: '', duration: 0.3, ease: 'power2.inOut' });
  };

  const animatePricesOpen = ($prices, $item) => {
    const fullHeight = $prices[0].scrollHeight;
    gsap.fromTo(
      $prices[0],
      { height: 0 },
      {
        height: fullHeight,
        duration: 0.2,
        ease: 'power2.out',
        onUpdate: () => {
          if (isDesktop) setItemsMinHeight($item[0].scrollHeight);
        },
        onComplete: () => {
          $prices.addClass('expanded');
          if (isDesktop) {
            setItemsMinHeight($item[0].scrollHeight, true);
            ScrollTrigger.refresh();
          }
        },
      }
    );
  };

  const animatePricesClose = ($prices, card) => {
    gsap.to($prices[0], {
      height: 0,
      duration: 0.4,
      ease: 'power2.inOut',
      overwrite: true,
      onUpdate: () => {
        setItemsMinHeight(getTallestCardHeight());
      },
      onComplete: () => {
        $prices.removeClass('expanded');
        ScrollTrigger.refresh();
        resetFlexBasis(card);
      },
    });
  };

  $(document).on('click', '.services__button', function () {
    const $item = $(this).closest('.services__item');
    const $prices = $item.find('.services__prices');
    if (!$prices.length) return;

    if (isDesktop && !$item.hasClass('active')) return;

    const isOpen = $prices.hasClass('expanded');

    if (isOpen) {
      $item.removeClass('item-expanded');
      animatePricesClose($prices, $item[0]);
    } else {
      $item.addClass('item-expanded');
      const image = $item.find('.services__item-image')[0];
      const content = $item.find('.services__item-content')[0];

      if (isDesktop) {
        const tl = gsap.timeline();

        if (image)
          tl.to(image, { flexBasis: 0, duration: 0.35, ease: 'power2.inOut' });

        if (content)
          tl.to(content, {
            flexBasis: '100%',
            duration: 0.35,
            ease: 'power2.inOut',
          });

        tl.add(() => {
          setTimeout(() => {
            animatePricesOpen($prices, $item);
          }, 350);
        });
      } else {
        animatePricesOpen($prices, $item);
      }
    }
  });

  $(document).on('click', '.services__head-item', function (e) {
    e.preventDefault();
    const targetIdx = $(this).index();
    const targetCard = cards[targetIdx];

    if (isDesktop && mainTimeline && mainTimeline.scrollTrigger) {
      const scrollPos = mainTimeline.scrollTrigger.labelToScroll(
        `step_${targetIdx}`
      );
      gsap.to(window, {
        scrollTo: { y: scrollPos, autoKill: false },
        duration: 1,
        ease: 'power2.inOut',
      });
    } else {
      gsap.to(window, {
        scrollTo: { y: targetCard, offsetY: 80, autoKill: false },
        duration: 1,
        ease: 'power2.inOut',
      });
    }
  });

  mm.add('(min-width: 1024px)', () => {
    isDesktop = true;
    let lastActiveIdx = 0;

    const getTallestCardHeight = () => {
      let max = 0;
      cards.forEach((card) => {
        max = Math.max(max, card.scrollHeight);
      });
      return max;
    };

    cards.forEach((card, i) => {
      gsap.set(card, {
        zIndex: cards.length - i,
        transformOrigin: 'center bottom',
      });
      if (i !== 0) gsap.set(card, { scale: 0.8, filter: 'brightness(0.5)' });
    });

    const updateClasses = (index) => {
      if (
        lastActiveIdx === cards.length - 1 &&
        index === 0 &&
        window.scrollY > items.offsetTop + 200
      )
        return;
      if (index === lastActiveIdx) return;

      lastActiveIdx = index;

      cards.forEach((card, idx) => {
        const isActive = idx === index;
        card.classList.toggle('active', isActive);

        const prices = card.querySelector('.services__prices');
        if (!isActive && prices && prices.classList.contains('expanded')) {
          animatePricesClose($(prices), card);
        }
      });

      setItemsMinHeight(cards[index].scrollHeight, true);
    };

    cards[0].classList.add('active');
    setItemsMinHeight(getTallestCardHeight());

    mainTimeline = gsap.timeline({
      defaults: { ease: 'none' },
      scrollTrigger: {
        trigger: items,
        start: 'top 125px',
        end: () => `+=${(cards.length - 1) * window.innerHeight * 1.1}`,
        pin: true,
        scrub: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate(self) {
          const triggerLine = window.innerHeight * 0.3;
          let foundActive = 0;
          if (self.progress > 0.98) {
            foundActive = cards.length - 1;
          } else {
            for (let i = 0; i < cards.length; i++) {
              const rect = cards[i].getBoundingClientRect();
              if (rect.bottom > triggerLine) {
                foundActive = i;
                break;
              }
            }
          }
          updateClasses(foundActive);
        },
      },
    });

    cards.forEach((card, i) => {
      mainTimeline.addLabel(`step_${i}`);
      if (i < cards.length - 1) {
        mainTimeline
          .to(card, { yPercent: -100, y: -40, duration: 1 }, `step_${i}`)
          .to(
            cards[i + 1],
            { scale: 1, filter: 'brightness(1)', duration: 1 },
            `step_${i}`
          );
      }
    });

    return () => {
      isDesktop = false;
      mainTimeline = null;
      cards.forEach((card) => {
        card.classList.remove('active', 'item-expanded');
        const prices = card.querySelector('.services__prices');
        if (prices) {
          $(prices).css({ height: '', overflow: '' });
          $(prices).removeClass('expanded');
        }
        resetFlexBasis(card);
      });
      gsap.set([items, ...cards], { clearProps: 'all' });
    };
  });
});
